import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateApplication } from "../../../../store/reducers/applicationSlice";
import { createNotification } from "../../../../store/reducers/notificationSlice";
import { hideDiv, showDiv } from "../../../../utility/utility";

const Index = ({
    selectedFieldData,
    setSelectedFieldData,
    formId,
    formIds,
    currentPage,
    setCurrentPage,
    applicationUserId
}) => {

    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);
    const currentApp = useSelector((state) => state.applications.currentApp);

    const authToken = user?.access_to;
    const accessToken = user?.access_token;

    // ----------------------------------------
    //  ADD DISCREPANCY
    // ----------------------------------------
    const handleAddDiscrepancy = async () => {
        const currentTime = new Date().toLocaleTimeString();

        await dispatch(
            updateApplication({
                accessToken,
                id: formId,
                currentTime,
                descripencie: selectedFieldData
            })
        );

        const appName = currentApp?.name || 'Application';
        const appId = currentApp?.id || formId;
        const statusText = 'Discrepancies';
        const subject = `Application Status Update: ${appName} (GB-${appId})`;
        const htmlContent = `
                <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
                    <h2 style="color: #2c3e50;">Application Status Update</h2>
                    <p>Dear User,</p>
                    <p>Your application <strong>${appName}</strong> (ID: <strong>GB-${appId}</strong>) has been updated.</p>
                    <p><strong>New Status:</strong> <span style="color: #007bff; font-weight: bold;">${statusText}</span></p>
                    <p>Please log in to your dashboard to view more details.</p>
                    <br>
                    <p>Best regards,</p>
                    <p><strong>Gaming Board Team</strong></p>
                </div>
            `;

        dispatch(
            createNotification({
                message: `Your application ${appName} (GB-${appId}) status has been updated to ${statusText}.`,
                userId: applicationUserId,
                accessToken: accessToken,
                is_admin: false,
                subject: subject,
                htmlMailContent: htmlContent,
                sendToCompanyAdmins: true
            })
        );
    };

    // ----------------------------------------
    //  TEXT INPUT CHANGE
    // ----------------------------------------
    const handleInputChange = (id, value) => {
        const cleanId = id.replace("_text", "");

        setSelectedFieldData((prev) => ({
            ...prev,
            [cleanId]: { ...prev[cleanId], value }
        }));
    };

    // ----------------------------------------
    //  REMOVE DISCREPANCY
    // ----------------------------------------
    const handleCheckboxChange = (id) => {
        const cleanId = id.replace("_check", "");
        const fieldId = cleanId.replace("dis_", "");

        setSelectedFieldData((prev) => {
            const updated = { ...prev };
            delete updated[cleanId];
            return updated;
        });

        const el = document.getElementById(fieldId);
        if (el) el.style.backgroundColor = "";
    };

    // ----------------------------------------
    //  JUMP TO FIELD & PAGE
    // ----------------------------------------
    const handleEyeClick = (discrepancyId) => {
        if (!discrepancyId) return;

        const fieldId = discrepancyId.replace("dis_", "");

        // Extract last segment as page number
        let parts = fieldId.split("_");
        let rawPage = parts[parts.length - 1];

        // Validate page number
        if (!rawPage || isNaN(rawPage)) {
            console.warn("⚠ Invalid page extracted:", rawPage);
            return;
        }

        const pageId = String(parseInt(rawPage));

        // Ensure props exist
        if (!setCurrentPage || typeof setCurrentPage !== "function") {
            console.warn("❌ setCurrentPage was not passed from the parent component");
            return;
        }

        // Ensure both old & new pages exist before switching
        if (currentPage && pageId && currentPage !== pageId) {
            hideDiv(currentPage);
            showDiv(pageId);
            setCurrentPage(pageId);
        }

        // Scroll to field & highlight
        const el = document.getElementById(fieldId);
        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });

            const previous = el.style.backgroundColor;
            el.style.backgroundColor = "#ffff99";

            setTimeout(() => {
                el.style.backgroundColor = previous || "";
            }, 1000);
        }
    };

    return (
        <div className="discontainer">
            <div className="title">Add Discrepancies</div>

            <div className="disform">
                <div className="boardHeadRight">
                    <div className="boardFilter">
                        {Object.entries(selectedFieldData)
                            .filter(([id]) => !id.startsWith("other"))
                            .map(([id, data]) => {
                                const fieldId = id.replace("dis_", "");

                                return (
                                    <div
                                        key={id}
                                        className="form-check form-check-inline"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            marginBottom: "8px"
                                        }}
                                    >
                                        {/* Checkbox */}
                                        <input
                                            id={id + "_check"}
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={data.check}
                                            onChange={() => handleCheckboxChange(id)}
                                        />

                                        {/* Text Field */}
                                        <input
                                            id={id + "_text"}
                                            type="text"
                                            placeholder="Add discrepancy"
                                            value={data.value}
                                            onChange={(e) =>
                                                handleInputChange(id, e.target.value)
                                            }
                                            className="form-check-label"
                                            style={{ flex: 1 }}
                                        />

                                        {/* Eye Icon */}
                                        <div
                                            className="cursor-pointer"
                                            title={`Go to: ${fieldId}`}
                                            onClick={() => handleEyeClick(id)}
                                        >
                                            <svg
                                                fill="#000000"
                                                width="20px"
                                                height="20px"
                                                viewBox="0 0 24 24"
                                            >
                                                <path d="M21.92,11.6C19.9,6.91,16.1,4,12,4S4.1,6.91,2.08,11.6a1,1,0,0,0,0,.8C4.1,17.09,7.9,20,12,20s7.9-2.91,9.92-7.6A1,1,0,0,0,21.92,11.6ZM12,18c-3.17,0-6.17-2.29-7.9-6C5.83,8.29,8.83,6,12,6s6.17,2.29,7.9,6C18.17,15.71,15.17,18,12,18ZM12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z" />
                                            </svg>
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </div>

            <div className="buttonGroup">
                <button className="AppFormButton w-100" onClick={handleAddDiscrepancy}>
                    Update Discrepancies
                </button>
            </div>
        </div>
    );
};

export default Index;
